var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerlisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20295_1414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 8.00001C1.33337 4.85731 1.33337 3.28596 2.30968 2.30965C3.286 1.33334 4.85734 1.33334 8.00004 1.33334C11.1427 1.33334 12.7141 1.33334 13.6904 2.30965C14.6667 3.28596 14.6667 4.85731 14.6667 8.00001C14.6667 11.1427 14.6667 12.7141 13.6904 13.6904C12.7141 14.6667 11.1427 14.6667 8.00004 14.6667C4.85734 14.6667 3.286 14.6667 2.30968 13.6904C1.33337 12.7141 1.33337 11.1427 1.33337 8.00001Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.52435L4.00008 5.52435",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5686 8.07336H3.99998",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5686 10.6224H3.99998",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1373 7.05377C10.6196 7.05377 10.1999 7.47345 10.1999 7.99115C10.1999 8.50885 10.6196 8.92853 11.1373 8.92853C11.655 8.92853 12.0747 8.50885 12.0747 7.99115C12.0747 7.47345 11.655 7.05377 11.1373 7.05377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5453 9.22455C10.0276 9.22455 9.60791 9.64423 9.60791 10.1619C9.60791 10.6796 10.0276 11.0993 10.5453 11.0993H11.7294C12.2471 11.0993 12.6667 10.6796 12.6667 10.1619C12.6667 9.64423 12.2471 9.22455 11.7294 9.22455H10.5453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20295_1414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerlisting);
export default __webpack_public_path__ + "static/media/Customer listing.a38fe7592a7ae880b8c96e7be8b0aeb8.svg";
export { ForwardRef as ReactComponent };